var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExportIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9731 4.88449L11.4187 0.39604C11.1546 0.132013 10.7916 0 10.4286 0H2.50777C1.38566 0 0.428558 0.924092 0.428558 2.07921V17.9208C0.428558 19.0429 1.35266 20 2.50777 20H14.2899C15.4121 20 16.3692 19.0759 16.3692 17.9208V5.87459C16.3692 5.51156 16.2371 5.14852 15.9731 4.88449ZM11.4517 2.50825L13.9269 4.9505H11.4517V2.50825ZM14.3229 18.4818H2.50777C2.17774 18.4818 1.91371 18.2178 1.91371 17.8878V2.0462C1.91371 1.71617 2.17774 1.45214 2.50777 1.45214H9.96652V5.67657C9.96652 6.07261 10.2965 6.43565 10.7256 6.43565H14.917V17.8878C14.884 18.2178 14.62 18.4818 14.3229 18.4818Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.47134 8.11907C9.17431 7.82204 8.71227 7.82204 8.41524 8.11907C8.11821 8.4161 8.11821 8.87815 8.41524 9.17518L10.3954 11.1884H4.68586C4.28982 11.1884 3.92679 11.5184 3.92679 11.9475C3.92679 12.3765 4.25682 12.7065 4.68586 12.7065H10.3954L8.41524 14.7197C8.11821 15.0168 8.11821 15.4788 8.41524 15.7758C8.54725 15.9079 8.74527 15.9739 8.94329 15.9739C9.14131 15.9739 9.33933 15.9079 9.47134 15.7428L12.7057 12.4755C13.0027 12.1785 13.0027 11.7164 12.7057 11.4194L9.47134 8.11907Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportIcon);
export default __webpack_public_path__ + "static/media/export-icon.101d4baba91c3b5bc07a4f21e6616dbd.svg";
export { ForwardRef as ReactComponent };